export default "__VITE_ASSET__eY8IWC0___"